import { Close as CloseIcon } from "@mui/icons-material";
import { Box } from "@mui/material";

import { theme } from "@/src/theme/theme";

interface LightboxCloseButtonProps {
  onClose: () => void;
  isMobile: boolean;
}

export const LightboxCloseButton = ({
  onClose,
  isMobile
}: LightboxCloseButtonProps) => {
  return (
    <Box
      onClick={onClose}
      sx={{
        position: "absolute",
        top: 0,
        right: 0,
        width: isMobile ? "60px" : "80px",
        height: isMobile ? "60px" : "80px",
        backgroundColor: theme.palette.misc.backdropOverlay,
        clipPath: "polygon(0 0, 100% 0, 100% 100%)",
        zIndex: 30,
        cursor: "pointer",
        WebkitTapHighlightColor: "transparent",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "flex-end",
        padding: isMobile ? "8px 8px 0 0" : "12px 12px 0 0",
        transition: "background-color 0.2s ease",
        backdropFilter: "blur(4px)",
        userSelect: "none",
        WebkitUserSelect: "none",
        WebkitTouchCallout: "none",
        "&:hover": {
          backgroundColor: theme.palette.text.primary
        }
      }}
      aria-label="Close lightbox"
    >
      <CloseIcon
        sx={{
          color: theme.palette.common.white,
          fontSize: isMobile
            ? theme.typography.subtitle3.fontSize
            : theme.typography.h4.fontSize
        }}
      />
    </Box>
  );
};
